var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _c("div", { staticClass: "breadcrumb" }, [
              _vm._v(" " + _vm._s(_vm.title) + " "),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "8", lg: "9", xl: "10" } },
                            [
                              _c("w-input", {
                                attrs: { label: "Title", fancy: "" },
                                model: {
                                  value: _vm.item.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "title", $$v)
                                  },
                                  expression: "item.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4", lg: "3", xl: "2" } },
                            [
                              _c("app-select-app", {
                                attrs: {
                                  fancy: "",
                                  items: _vm.appItems,
                                  label: "App",
                                },
                                model: {
                                  value: _vm.item.appName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "appName", $$v)
                                  },
                                  expression: "item.appName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            {
                              staticClass: "vertical-center",
                              attrs: { xs: "12", md: "3" },
                            },
                            [
                              _c("w-checkbox", {
                                attrs: { label: "Is Comming Soon" },
                                model: {
                                  value: _vm.item.isCommingSoon,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "isCommingSoon", $$v)
                                  },
                                  expression: "item.isCommingSoon",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            {
                              staticClass: "vertical-center",
                              attrs: { xs: "12", md: "3" },
                            },
                            [
                              _c("w-checkbox", {
                                attrs: { label: "Nog in ontwerp" },
                                model: {
                                  value: _vm.item.inDevelopment,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "inDevelopment", $$v)
                                  },
                                  expression: "item.inDevelopment",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-select-roadmap-status", {
                                attrs: { label: "Status", fancy: "" },
                                model: {
                                  value: _vm.item.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "status", $$v)
                                  },
                                  expression: "item.status",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            {
                              staticClass: "vertical-center",
                              attrs: { xs: "12", md: "4", lg: "2" },
                            },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  value: _vm.hasDate,
                                  label: "Has date",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setHasDate($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "8", lg: "10" } },
                            [
                              _c("w-date-picker", {
                                attrs: {
                                  fancy: "",
                                  disabled: !_vm.hasDate,
                                  label: "Date",
                                },
                                model: {
                                  value: _vm.item.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "date", $$v)
                                  },
                                  expression: "item.date",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: { label: "Vimeo Link", fancy: "" },
                                model: {
                                  value: _vm.item.vimeoLink,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "vimeoLink", $$v)
                                  },
                                  expression: "item.vimeoLink",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("h2", [_vm._v("Intro")]),
                              _c("vue-editor", {
                                attrs: { "use-custom-image-handler": "" },
                                on: { "image-added": _vm.onImageAdded },
                                model: {
                                  value: _vm.item.intro,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "intro", $$v)
                                  },
                                  expression: "item.intro",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { staticClass: "mt", attrs: { xs: "12" } },
                            [
                              _c("h2", [_vm._v("Inhoud")]),
                              _c("vue-editor", {
                                attrs: { "use-custom-image-handler": "" },
                                on: { "image-added": _vm.onImageAdded },
                                model: {
                                  value: _vm.item.text,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.item, "text", $$v)
                                  },
                                  expression: "item.text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "save" } }),
                          _vm._v(" Save "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }